export const DENOM = "ufct";
export const SYMBOL = "FCT";

export const RESTAKE_API = {
  URI: 'https://restake-app-testnet.firmachain.dev:14000/',
  GET_STATUS: 'restake/status'
};

export const STATUS_API_INTERVAL = 1000 * 60 * 5;
export const BLOCKCHAIN_EXPLORER = "https://explorer-testnet.firmachain.dev"
export const GRAPHQL_CONFIG = `${BLOCKCHAIN_EXPLORER}:8080/v1/graphql`;
export const EXPLORER_TRANSACTION = `${BLOCKCHAIN_EXPLORER}/transactions`;
